/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// redux utils
import { createSlice } from '@reduxjs/toolkit';
import { history } from '@insticator/insticator-ui';



/* ========== ~~~~~~~~~~ INVOLVEMENT - CONFIGURATIONS SLICE : REDUCER ~~~~~~~~~~ ========== */
const getInitialState = () => ({
    // general
    feedbackQuestion: '',
    showOverview: false,
    timeRange: '',
    // color scheme
    colorScheme: {
        background: '#fff',
        primaryText: '#000',
        secondaryText: '#555',
        branding: '#ccc'
    },
    // external id
    enableExternalID: false
});


export const involvementConfigSlice = createSlice({
    name: 'involvementConfig',
    initialState: getInitialState(),
    reducers: {
        updateFeedback: (state, action) => {
            // console.log("@@@ TOGGLING SIDEBAR STATE @@@@", action.payload);
            state.feedbackQuestion = action.payload;
        }
    }
});


export const { updateFeedback } = involvementConfigSlice.actions;
export default involvementConfigSlice.reducer;
